import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarLoader from "../common-components/CalendarLoader.jsx";
import { CalenderIcon } from "../../images/icons/icons";

const FitnessProfileStatCards = ({ setFilters, selectedRange }) => {
  const {
    fitnessProfileStats,
    fitnessProfileStatsLoading,
    fitnessProfileStatsError,
  } = useSelector((state) => state.prospects);

  const [statsData, setStatsData] = useState(null);

  const getCardTitle = (key) => {
    const titles = {
      total_users: "Total Members with Fitness Profile",
      profiling_done: "Profiling Done",
      profiling_not_done: "Profiling Not Done",
      "0-7_days": "0-7 Days Pending",
      "7-14_days": "7-14 Days Pending",
      "14-21_days": "14-21 Days Pending",
      "21-30_days": "21-30 Days Pending",
      ">30_days": ">30 Days Pending",
    };
    return titles[key] || key;
  };

  const getCardIcon = (key) => {
    const icons = {
      total_users: <CalenderIcon />,
      profiling_done: <CalenderIcon />,
      profiling_not_done: <CalenderIcon />,
    };
    return icons[key] || <CalenderIcon />;
  };

  const getCardIconType = (key) => {
    const types = {
      total_users: "info",
      profiling_done: "success",
      profiling_not_done: "warning",
    };
    return types[key] || "danger";
  };

  const handleCardClick = (key, value) => {
    if (value > 0) {
      // For total_users card, clear the filter (show all)
      if (key === "total_users") {
        setFilters((prevs) => ({
          ...prevs,
          fitness_milestone: "",
        }));
        return;
      }

      // For profiling_done card, set filter to "done"
      if (key === "profiling_done") {
        // Toggle off if already selected
        if (selectedRange === "done") {
          setFilters((prevs) => ({
            ...prevs,
            fitness_milestone: "",
          }));
        } else {
          setFilters((prevs) => ({
            ...prevs,
            fitness_milestone: "done",
          }));
        }
        return;
      }

      // For profiling_not_done card, set filter to "not_done"
      if (key === "profiling_not_done") {
        // Toggle off if already selected
        if (selectedRange === "not_done") {
          setFilters((prevs) => ({
            ...prevs,
            fitness_milestone: "",
          }));
        } else {
          setFilters((prevs) => ({
            ...prevs,
            fitness_milestone: "not_done",
          }));
        }
        return;
      }

      // If clicking the already selected card, clear the filter (toggle off)
      if (selectedRange === key) {
        setFilters((prevs) => ({
          ...prevs,
          fitness_milestone: "",
        }));
        return;
      }

      // Otherwise, set the new filter with the key as-is (e.g., '0-7_days', '7-14_days', etc.)
      setFilters((prevs) => ({
        ...prevs,
        fitness_milestone: key,
      }));
    }
  };
  
  useEffect(() => {
    if (
      !fitnessProfileStatsLoading &&
      !fitnessProfileStatsError &&
      fitnessProfileStats?.status
    ) {
      setStatsData(fitnessProfileStats?.data);
    } else {
      setStatsData(null);
    }
  }, [
    fitnessProfileStatsLoading,
    fitnessProfileStatsError,
    fitnessProfileStats,
  ]);

  return (
    <div className="mr-kpi-grid mt30">
      {fitnessProfileStatsLoading ? (
        <CalendarLoader daysCount={8} shiftsPerDay={2} />
      ) : (
        statsData &&
        Object.entries(statsData)?.map(([key, value]) => {
          const isClickable = value > 0;
          // Handle special card selection states
          let isSelected = false;
          if (key === "profiling_done") {
            isSelected = selectedRange === "done";
          } else if (key === "profiling_not_done") {
            isSelected = selectedRange === "not_done";
          } else {
            isSelected = selectedRange === key;
          }

          return (
            <div
              className={`mr-kpi-card ${
                isClickable ? "mr-kpi-card--clickable" : ""
              } ${isSelected ? "mr-kpi-card--selected" : ""}`}
              key={key}
              onClick={() => handleCardClick(key, value)}
              style={{
                cursor: isClickable ? "pointer" : "default",
                border: isSelected ? "2px solid #157EF9" : "1px solid #e0e0e0",
                boxShadow: isSelected
                  ? "0 4px 12px rgba(21, 126, 249, 0.2)"
                  : "none",
              }}
              title={isClickable ? `View ${getCardTitle(key)}` : ""}
            >
              <div className="mr-kpi-head">
                <div>
                  <p className="mr-kpi-title">{getCardTitle(key)}</p>
                  <div className="mr-kpi-value-row">
                    <div className="mr-kpi-value">{value}</div>
                  </div>
                </div>
                <span
                  className={`mr-kpi-icon mr-kpi-icon--${getCardIconType(key)}`}
                >
                  {getCardIcon(key)}
                </span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default FitnessProfileStatCards;
